import { stripHtml } from "#/shared/utils/string";

/**
 * Computes the detail payload for a decision-tree:progress event.
 *
 * @param {Object} params
 * @param {Object} params.currNode - The node being navigated to
 * @param {Object|null} params.prevNode - The node being navigated away from (null on first fire)
 * @param {Array} params.previousNodes - The decision tree's history stack
 * @param {number} params.progressPercent - Current progress percentage
 * @param {Object} params.currentState - Current decision tree state
 * @returns {Object} The detail object for the CustomEvent
 */
export function buildProgressDetail({ currNode, prevNode = null, previousNodes, progressPercent, currentState }) {
  const isForwardNavigation = prevNode != null && previousNodes.at(-1) === prevNode;
  const completedNodeAnalytics = isForwardNavigation ? (prevNode?.analyticsSummary ?? null) : null;
  const stepSequence = previousNodes.filter((n) => n.analyticsSummary != null).length;

  return {
    value: progressPercent,
    currentState,
    completedNodeAnalytics,
    stepSequence,
    questionText: stripHtml(currNode.questionText || "").trim(),
    nodeType: currNode.name,
    nodeId: currNode.id,
  };
}
